const BASE_WP_URL = process.env.BASE_WP_URL;

export default {
  userPreferenceDefinitions: '/authentication/preferencedefinitions',
  userProfile: '/authentication/profile',
  memberProfile: '/authentication/memberProfile',
  avatar: '/authentication/profile/avatar',
  authenticate: '/authentication/request',
  checkAuthentication: '/authentication/authenticate',
  spotIMSSO: '/authentication/spotim',
  disqusSSO: '/authentication/disqus',
  facebookAuthenticate: '/authentication/facebook',
  markArticleRead: '/v2/articles/mark_read',
  markArticleSeen: '/v2/articles/mark_seen',
  markHolidayRead: '/v2/holidays/mark_read',
  markHolidaySeen: '/v2/holidays/mark_seen',
  markHolidayInterest: '/v2/holidays/mark_interest',
  holidayLeads: '/v2/holidays/leads',
  v3HolidayLeads: '/v3/holiday-leads',
  holidayFeed: '/v2/holidays/feed',
  subscriptions: '/v2/subscriptions',
  unsubscribe: '/v2/subscriptions/unsubscribe',
  searchLocations: '/v2/locations/search',
  searchAirports: '/v2/airports/search',
  agentSelectAddresses: '/v2/leads/agentselect/addresses',
  hubLeads: '/v2/leads/hubs',
  suggestedArticles: `${BASE_WP_URL}/wp-json/sas/suggested_articles`,
  suggestedHolidays: '/v2/holidays/recommend',
  checkDD: '/v2/dd/getId',
  collectSubscriber: '/v2/users/collect',
  updateDotDigitalContact: '/v2/dd/updateContact',
  holidayBase: `/v2/holidays`,
  userTracking: '/v2/users/tracking',
  userTrackingArticleBackfill: '/v2/users/tracking/article_backfill',

  getCompetitionVotesByEmailAndSlug: '/v2/users/competition_votes',
  postCompetitionVote: '/v2/users/competition',

  getNextNav: `/wp-json/sas/next_get_nav`,
  getNextFooter: `/wp-json/sas/next_get_footer`,

  dotDigitalSendTriggeredCampaign: `/v2/dd/sendTriggeredCampaign`,
};
